/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface AppointVisitPaymentDto
 */
export interface AppointVisitPaymentDto {
    /**
     * 
     * @type {string}
     * @memberof AppointVisitPaymentDto
     */
    'discountPrice'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AppointVisitPaymentDto
     */
    'installments'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AppointVisitPaymentDto
     */
    'paymentMarking'?: AppointVisitPaymentDtoPaymentMarkingEnum;
    /**
     * 
     * @type {string}
     * @memberof AppointVisitPaymentDto
     */
    'paymentProvider'?: AppointVisitPaymentDtoPaymentProviderEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum AppointVisitPaymentDtoPaymentMarkingEnum {
    WaitingForPayment = 'WAITING_FOR_PAYMENT',
    PaymentReceived = 'PAYMENT_RECEIVED'
}
/**
    * @export
    * @enum {string}
    */
export enum AppointVisitPaymentDtoPaymentProviderEnum {
    Payu = 'PAYU',
    Paynow = 'PAYNOW'
}


